module.exports = __webpack_public_path__ + "img/bg_checkbox_disabled.d748d310.svg";